import ReactMarkdown from "react-markdown";

const G = {
  text: "#E4E4DC", muted: "#666", accent: "#00C896",
  purple: "#7C6FFF", border: "#1E1E1E",
  font: "'Sora', sans-serif", mono: "'DM Mono', monospace",
};

export default function MarkdownRenderer({ content }) {
  return (
    <div style={{ fontFamily: G.font, color: G.text, lineHeight: 1.8, fontSize: 15 }}>
      <ReactMarkdown
        components={{
          p: ({ children }) => (
            <p style={{ marginBottom: 12, color: "#CCC", lineHeight: 1.8 }}>{children}</p>
          ),
          h1: ({ children }) => (
            <h1 style={{ fontSize: 20, fontWeight: 700, color: G.text, margin: "18px 0 10px" }}>{children}</h1>
          ),
          h2: ({ children }) => (
            <h2 style={{ fontSize: 17, fontWeight: 700, color: G.text, margin: "16px 0 8px" }}>{children}</h2>
          ),
          h3: ({ children }) => (
            <h3 style={{ fontSize: 15, fontWeight: 600, color: G.text, margin: "14px 0 6px" }}>{children}</h3>
          ),
          strong: ({ children }) => (
            <strong style={{ color: G.text, fontWeight: 700 }}>{children}</strong>
          ),
          em: ({ children }) => (
            <em style={{ color: "#AAA", fontStyle: "italic" }}>{children}</em>
          ),
          code: ({ inline, children }) =>
            inline ? (
              <code style={{ background: "#1A1A1A", border: `1px solid ${G.border}`, color: G.accent, padding: "2px 7px", borderRadius: 5, fontFamily: G.mono, fontSize: 13 }}>
                {children}
              </code>
            ) : (
              <pre style={{ background: "#0D0D0D", border: `1px solid ${G.border}`, borderRadius: 8, padding: "14px 16px", overflowX: "auto", margin: "12px 0" }}>
                <code style={{ fontFamily: G.mono, fontSize: 13, color: "#A8E6CF", lineHeight: 1.6 }}>
                  {children}
                </code>
              </pre>
            ),
          ul: ({ children }) => (
            <ul style={{ paddingLeft: 20, marginBottom: 12, color: "#CCC" }}>{children}</ul>
          ),
          ol: ({ children }) => (
            <ol style={{ paddingLeft: 20, marginBottom: 12, color: "#CCC" }}>{children}</ol>
          ),
          li: ({ children }) => (
            <li style={{ marginBottom: 4, lineHeight: 1.7 }}>{children}</li>
          ),
          blockquote: ({ children }) => (
            <blockquote style={{ borderLeft: `3px solid ${G.purple}`, paddingLeft: 14, margin: "12px 0", color: G.muted, fontStyle: "italic" }}>
              {children}
            </blockquote>
          ),
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noopener noreferrer" style={{ color: G.accent, textDecoration: "underline" }}>
              {children}
            </a>
          ),
          hr: () => (
            <hr style={{ border: "none", borderTop: `1px solid ${G.border}`, margin: "16px 0" }} />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
